<template>
	<div :class="[(props.time || props.subTitle) && 'title-bar']">
		<div class="box">
			<div class="box-title">
				<h1 class="box-title_item">
					{{ props.title }}<strong>{{ props.highlight }}</strong>
				</h1>
				<div v-if="$props.content" class="btn_box">
					<button
						:class="['btn_tooltip', displayStore.isSmallScreen ? props.position : 'center']"
						@mousemove="
							deviceStore.getDevice === 'MO' ? (isTooltipOpened = !isTooltipOpened) : (isTooltipOpened = true)
						"
						@mouseout="isTooltipOpened = false"
					>
						<img src="@/assets/img/common/question.svg" alt="툴팁 아이콘" loading="lazy" />
					</button>
					<div v-if="isTooltipOpened" :class="['box_tooltip', props.position]">
						<p class="tooltip_title">
							{{ props.content }}
						</p>
					</div>
				</div>
			</div>

			<button v-if="$props.hasView" class="c_button font-s-semi font-bold" type="button" @click="onClickViewAll">
				<span>전체보기</span>
				<img class="btn_img" src="@/assets/img/common/arrow_next.svg" alt="전체보기 아이콘" loading="lazy" />
			</button>
		</div>
		<time v-if="$props.time">{{ $props.time }}</time>
		<p v-if="props.subTitle">{{ props.subTitle }}</p>
	</div>
</template>
<script setup lang="ts">
// core
import { ref } from 'vue';

import { useDeviceStore } from '@/stores/device';
import { useDisplayStore } from '@/stores/display';

// -----variable-----
const props = defineProps<{
	title: string;
	subTitle?: string;
	hasView: boolean;
	content?: string;
	time?: string;
	highlight?: string;
	position?: 'left' | 'center' | 'right';
}>();

const emit = defineEmits(['onClickViewAll']);

const displayStore = useDisplayStore();
const deviceStore = useDeviceStore();

const isTooltipOpened = ref(false);

// -----function-----
const onClickViewAll = async () => {
	emit('onClickViewAll');
};
</script>

<style lang="scss" scoped>
.title-bar {
	display: flex;
	flex-direction: column;
	time {
		padding-top: 1rem;
		color: var(--color-base-light);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: normal;
	}
	p {
		padding-top: 0.4rem;
		color: var(--color-base-white);
		font-size: var(--font-s-regular);
		font-weight: var(--font-w-light);
		line-height: 2.3rem;
	}
	strong {
		color: red;
	}
}
.box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	// @media screen and (max-width: 1280px) {
	// 	padding: 0rem 2rem;
	// }
	&-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--space-x-small);
		&_item {
			font-size: var(--font-s-x-large);
			font-weight: var(--font-w-bold);
			line-height: normal;
		}
		.btn_box {
			display: flex;
			position: relative;
			.left {
				left: -4rem;
			}
			.center {
				left: -10rem;
			}
			.right {
				left: -16rem;
			}
			.box_tooltip {
				display: flex;
				flex-direction: column;
				align-items: start;
				gap: 1rem;
				position: absolute;
				top: 3rem;

				z-index: 10;
				width: 24rem;
				background-color: var(--color-bg-light);
				padding: 1.6rem;
				border-radius: 0.8rem;
				box-shadow: 4px 4px 10px 0px #0000004d;
				.tooltip_title {
					font-size: var(--font-s-mid);
					font-weight: var(--font-w-light);
					line-height: 1.9rem;
				}
				.tooltip_content {
					display: flex;
					flex-direction: column;
					font-size: var(--font-s-mid);
					gap: 1rem;
					.tooltip_content_item {
						display: flex;
						gap: 1.6rem;
					}
					.content_title {
						width: 7rem;
						font-weight: var(--font-w-light);
						line-height: 1.9rem;
					}
					.content_description {
						font-weight: var(--font-w-medium);
						line-height: 1.79rem;
						strong {
							color: var(--color-secondary);
						}
					}
				}
			}
			.btn_tooltip {
				// @media screen and (max-width: 360px) {
				// 	img {
				// 		width: 2.4rem;
				// 	}
				// }
			}
		}
	}
	.c_button {
		line-height: normal;
		padding: 0rem;
		.btn_img {
			height: 1.8rem;
			width: auto;
			padding: 0rem;
		}
	}
}
</style>
